/* Nova Storify – theme script.
   Cart drawer, cart page updates, quantity steppers, product recommendations, collection sort and filters. */
(function () {
  'use strict';
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var slice = Array.prototype.slice;
  function all(scope, sel) { return slice.call((scope || document).querySelectorAll(sel)); }

  function postCart(path, body) {
    return fetch(ROOT + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function sectionHtml(html, id) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.getElementById('shopify-section-' + id) || doc.body;
  }

  /* ================= cart drawer ================= */
  var DRAWER_ID = 'nv-cart-drawer';
  if (window.customElements && !customElements.get('cart-drawer')) {
    class CartDrawer extends HTMLElement {}
    CartDrawer.prototype.connectedCallback = function () {
      var self = this;
      if (self.__ready) return;
      self.__ready = true;
      self.addEventListener('click', function (e) {
        var t = e.target;
        if (t.closest('[data-nvc-close]')) { self.close(); return; }
        var q = t.closest('[data-nvc-qty]');
        if (q) { self.step(q.closest('[data-line]'), +q.getAttribute('data-nvc-qty')); return; }
        var rm = t.closest('[data-nvc-remove]');
        if (rm) { self.change(rm.closest('[data-line]'), 0); }
      });
      self.addEventListener('change', function (e) {
        var input = e.target;
        if (input.matches && input.matches('[data-nvc-input]')) self.change(input.closest('[data-line]'), Math.max(0, parseInt(input.value, 10) || 0));
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && self.classList.contains('is-open')) self.close(); });
    };
    CartDrawer.prototype.open = function (trigger) {
      this.__trigger = trigger || document.activeElement;
      this.classList.add('is-open');
      document.documentElement.classList.add('nv-lock');
      var panel = this.querySelector('.nvc-panel');
      if (panel) { try { panel.focus({ preventScroll: true }); } catch (e) {} }
    };
    CartDrawer.prototype.close = function () {
      this.classList.remove('is-open');
      document.documentElement.classList.remove('nv-lock');
      if (this.__trigger && this.__trigger.focus) { try { this.__trigger.focus({ preventScroll: true }); } catch (e) {} }
    };
    CartDrawer.prototype.getSectionsToRender = function () {
      return [{ id: DRAWER_ID, section: DRAWER_ID, selector: 'cart-drawer' }];
    };
    /* takes a /cart/*.js response that includes "sections" and swaps in the fresh drawer */
    CartDrawer.prototype.renderContents = function (res) {
      var html = res && res.sections && res.sections[DRAWER_ID];
      if (!html) return;
      var fresh = sectionHtml(html, DRAWER_ID).querySelector('cart-drawer');
      if (!fresh) return;
      var self = this;
      ['[data-nvc-body]', '[data-nvc-foot]', '[data-nvc-title]'].forEach(function (sel) {
        var a = self.querySelector(sel), b = fresh.querySelector(sel);
        if (a && b) a.innerHTML = b.innerHTML;
      });
      var count = fresh.getAttribute('data-count') || '0';
      self.setAttribute('data-count', count);
      self.classList.toggle('is-empty', fresh.classList.contains('is-empty'));
      all(document, '[data-cart-count]').forEach(function (el) { el.textContent = count; el.hidden = count === '0'; });
      var err = self.querySelector('[data-nvc-error]');
      if (err) err.hidden = true;
      self.classList.remove('is-busy');
      self.open(document.activeElement);
    };
    CartDrawer.prototype.step = function (row, delta) {
      if (!row) return;
      var input = row.querySelector('[data-nvc-input]');
      var next = Math.max(0, (parseInt(input && input.value, 10) || 0) + delta);
      this.change(row, next);
    };
    CartDrawer.prototype.change = function (row, quantity) {
      if (!row) return;
      var self = this;
      self.classList.add('is-busy');
      postCart('cart/change.js', { line: +row.getAttribute('data-line'), quantity: quantity, sections: DRAWER_ID, sections_url: window.location.pathname })
        .then(function (res) {
          if (res && res.status) throw new Error(res.description || res.message || '');
          self.renderContents(res);
        })
        .catch(function (err) {
          self.classList.remove('is-busy');
          var box = self.querySelector('[data-nvc-error]');
          if (box) { box.textContent = (err && err.message) || 'Could not update the cart. Please try again.'; box.hidden = false; }
        });
    };
    customElements.define('cart-drawer', CartDrawer);
  }

  /* ================= cart page ================= */
  function initCartPage(root) {
    if (!root || root.__nvReady) return;
    root.__nvReady = true;
    var sid = root.getAttribute('data-section');
    function reload(line, quantity) {
      root.classList.add('is-busy');
      postCart('cart/change.js', { line: line, quantity: quantity, sections: sid, sections_url: window.location.pathname })
        .then(function (res) {
          if (res && res.status) throw new Error(res.description || res.message || '');
          var wrap = document.getElementById('shopify-section-' + sid);
          var fresh = sectionHtml(res.sections[sid], sid);
          if (wrap && fresh) { wrap.innerHTML = fresh.innerHTML; initCartPage(wrap.querySelector('[data-nv-cart]')); }
          all(document, '[data-cart-count]').forEach(function (el) { el.textContent = res.item_count; el.hidden = !res.item_count; });
        })
        .catch(function (err) {
          root.classList.remove('is-busy');
          var box = root.querySelector('[data-nv-cart-error]');
          if (box) { box.textContent = (err && err.message) || 'Could not update the cart. Please try again.'; box.hidden = false; }
        });
    }
    root.addEventListener('click', function (e) {
      var q = e.target.closest('[data-nv-qty]');
      if (q) {
        var row = q.closest('[data-line]'), input = row.querySelector('[data-nv-input]');
        reload(+row.getAttribute('data-line'), Math.max(0, (parseInt(input.value, 10) || 0) + (+q.getAttribute('data-nv-qty'))));
        return;
      }
      var rm = e.target.closest('[data-nv-remove]');
      if (rm) { e.preventDefault(); reload(+rm.closest('[data-line]').getAttribute('data-line'), 0); }
    });
    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-nv-input]')) reload(+e.target.closest('[data-line]').getAttribute('data-line'), Math.max(0, parseInt(e.target.value, 10) || 0));
    });
  }

  /* ================= product recommendations ================= */
  function initRelated(el) {
    if (!el || el.__nvReady || !window.fetch) return;
    el.__nvReady = true;
    fetch(el.getAttribute('data-url'))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-nv-related]');
        if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; el.classList.add('is-loaded'); }
        else el.hidden = true;
      })
      .catch(function () { el.hidden = true; });
  }

  /* ================= collection toolbar ================= */
  function initToolbar(form) {
    if (!form || form.__nvReady) return;
    form.__nvReady = true;
    all(form, '[data-nv-sort]').forEach(function (sel) { sel.addEventListener('change', function () { form.submit(); }); });
    document.addEventListener('click', function (e) {
      all(form, 'details[open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
    });
  }

  function boot(scope) {
    all(scope, '[data-nv-cart]').forEach(initCartPage);
    all(scope, '[data-nv-related]').forEach(initRelated);
    all(scope, '[data-nv-filters]').forEach(initToolbar);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });

  /* keep header cart counts fresh after any cart request made elsewhere */
  document.addEventListener('lg:cart-changed', function () {
    fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { all(document, '[data-cart-count]').forEach(function (el) { el.textContent = c.item_count; el.hidden = !c.item_count; }); })
      .catch(function () {});
  });
})();
